const cf = window.cf

const getRowText = (text) => {
  let resultText = text.replace(/[\r\n]+/gm, " ");
  return resultText;
}

const customItemRenderer = data => {
  const sentimentClass =
  data.sentiment == "Positive" ? "positive-tweet" : 
  data.sentiment == "Neutral" ? "neutral-tweet" : "negative-tweet";

  let categoriesData = data.kwd_category ? data.kwd_category.join(", ") : "";
  if (!data.kwd_category) {
       return { content: "No data..." };
  }

  const tweetText = getRowText(data.text);

  let cf = window.cf;
  let moment = cf.getDependency('moment');
  let tweetDate = moment(data.created_at, 'YYYY-MM-DD HH:mm:ss.SSS').toDate();
  const ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(tweetDate);
  const mo = new Intl.DateTimeFormat("en", { month: "short" }).format(tweetDate);
  const da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(tweetDate);
  const hr = new Intl.DateTimeFormat("en", { hour: "2-digit" }).format(tweetDate).split(" ");
  const min = new Intl.DateTimeFormat("en", { minute: "2-digit" }).format(tweetDate);
  const sec = new Intl.DateTimeFormat("en", { second: "2-digit" }).format(tweetDate);
  tweetDate = `${da} ${mo} ${ye}`;
  const tweetTime = `${hr[0].padStart(2, "0")}:${min.padStart(2, "0")}:${sec.padStart(2, "0")} ${hr[1]}`;
  const tweetBody = `
       <div class="tweet">
            <div class="tweet-img">
                 <div class="profile-img">
                      <img class="user-img" src="${data.user_profile_image_url}">
                 </div>
            </div>
            <div class="tweet-content">
                 <div class="tweet-header">
                 <a class="tweet-user-screen-name" target="_blank" href="https://twitter.com/${data.user_screen_name}">@${data.user_screen_name}</a>
                 <a class="tweet-user-screen-name"> - ${tweetDate} </a>
                 <a class="tweet-user-screen-name" target="_blank" href="https://twitter.com/${data.user_screen_name}/status/${data.tweet_id}"> ${tweetTime}</a> <br>
                 </div>
                 <div class="tweet-info">
                      <div class="text-row-item">${tweetText}</div>
                 </div>
                 <span class="tweet-class">
                 Sentiment: <a class="${sentimentClass}">${data.sentiment}</a><br>
                 Category: <a class="teewt-category">${categoriesData}</a>
                 </span>
            </div>
       </div>
       `;

  return { content: tweetBody };
};

export const dataList = () => {
return cf
 .provider("es01")
 .source("vc_airline_tweets")
 .fields("sentiment",
        "kwd_category",
        "text.keyword",
        "created_at",
        "user_profile_image_url",
        "user_screen_name",
        "tweet_id")
 .graph("Data List")
 .set("customOpts", { animateRows: true, rowHeight: 170  })
 .set("customItemRenderer", customItemRenderer)
 .set("keyField", "tweet_id")
 .set("sort", [{ created_at: "desc" }])
 .limit(100);
};

export const timeslider = function () {

    let provider = cf.provider('es01');
    let source = provider.source('vc_airline_tweets');
    let grid = cf.Grid().right(20).left(10);
    let field = cf.Attribute("created_at").func("DAY")
    let myData = source.timeField(field)
    let theme = {
        top: '#8ace7e', // Top bar of the slider
        mid: '#51b364', // Middle bar
        bottom: '#309143', // Bottom bar and field name background
        ticks: 'yellow', // Ticks and ticks labels
        selection: '#e9e9e9' // Range selection
    }
    let color = cf.Color().theme(theme)
    let myChart = myData.graph("Time Slider")
                .set("grid", grid)
                .set("color", color)
                .set("player", {
                        "enable": true,
                        'pin-left': true,
                        'step': 1,
                        'step-unit': 'day',
                        'refresh': 3,
                        'animation-delay': 0.4,
                        'live': false,
                        'autoplay': false
                });

    return myChart;
}

export const entities = function () {

    let provider = cf.provider('es01');
    let source = provider.source('vc_airline_tweets');
    let metric0 = cf.Metric("count");
    let group1 = cf.Attribute("entities.Text")
                .limit(10000)
                .sort("desc", metric0);

    let myData = source.groupby(group1)
        .metrics(metric0);
    let myChart = myData.graph("Slicer")
    .set('showHeaders', false)
    .set('sizeColumnsToFit', true);

    return myChart;
}

export const keyphrases = function () {

    let provider = cf.provider('es01');
    let source = provider.source('vc_airline_tweets');
    let metric0 = cf.Metric("count");
    let group1 = cf.Attribute("key_phrases.Text.keyword")
                .limit(10000)
                .sort("desc", metric0);

    let myData = source.groupby(group1)
        .metrics(metric0);
    let myChart = myData.graph("Slicer")
    .set('showHeaders', false)
    .set('sizeColumnsToFit', true);

    return myChart;
}

export const textsearch = function () {

    let myChart = cf.create()
    .graph("Text Search");

    return myChart;
}

export const tweettrend = function () {

    let provider = cf.provider("es01");
    let source = provider.source('vc_airline_tweets');
    let count = cf.Metric("count");
    const countComp = cf.CompareMetric()
                        .using('created_at')
                        .with('-7 day')
                        .label('Tweets last week')
                        .hideFunction();
    let group1 = cf.Attribute("created_at")
                .limit(1000)
                .func("DAY")
                .sort("asc","created_at");

    let myData = source.groupby(group1)
        .metrics(count, countComp);
    let legend = cf.Legend()
        .position("bottom")
        .width(150)
        .height(30)
        .sort("none");
    let grid = cf.Grid()
        .top(10)
        .right(30)
        .bottom(55)
        .left(65);
    let color = cf.Color()
        .palette(["#0095b7", "#a0b774", "#f4c658",
            "#fe8b3e", "#cf2f23", "#756c56",
            "#007896", "#47a694", "#f9a94b",
            "#ff6b30", "#e94d29", "#005b76"]);
    let myChart = myData.graph("Trend")
        .set("grid", grid)
        .set("color", color)
        .set("axisLabels", false)
        .set("dataZoom", true)
        // .set("legend", legend);

    return myChart;
}

export const counter = function () {
    let provider = cf.provider('es01');
    let source = provider.source('vc_airline_tweets');

    let metric0 = cf.Metric();
    // const growth = cf.CompareMetric()
    //                 .rate('growth')
    //                 .with('-7 days')
    //                 .using('created_at')
    //                 .label('Change previous week');
    // Add metrics and groups to data source
    let myData = source
                .metrics(metric0);

    let color = cf.Color();
    color.theme({
        primaryValue: '#5E666D', // Primary color value
        labels: '#5E666D', // Labels Color
    });
    let myChart = myData
                .set("color", color)
                .set("mainTextSize", 17)
                .set("secondaryTextSize", 15)
                .set("diffTextSize", 15)
                .set('diff', false)
                .set("labelTextSize", 10)
                .set("showLabels", true)
                .set("labelsTop", 10);

    return myChart;
}

export const categorypicker = function () {
    let provider = cf.provider('es01');
    let source = provider.source('vc_airline_tweets');
    let metric0 = cf.Metric("count");
    let group1 = cf.Attribute("kwd_category")
                .limit(10000)
                .sort("desc", metric0);

    let myData = source.groupby(group1)
        .metrics(metric0);
    let myChart = myData.graph("Slicer")
    .set('showHeaders', false)
    .set('sizeColumnsToFit', true);

    return myChart;
}

export const sankey = function () {
    let provider = cf.provider('es01');
    let source = provider.source('vc_airline_tweets');
    let grid = cf.Grid().left(10).right(100).bottom(10).top(10);
    let metric0 = cf.Metric("count");
    let myData = source
        .rows("kwd_category", "airline")
        .metrics(metric0);
    let myChart = myData.graph("Sankey")
        .set("grid", grid)
        .limit(10000);

    return myChart;
}


export const sentimentpercentage = function () {
    let provider = cf.provider('es01');
    let source = provider.source('vc_airline_tweets');
    const rate = cf.CompareMetric()
                        .rate()
                        .label('Percent');
    let metric0 = cf.Metric("count");
    let group1 = cf.Attribute("airline")
                .limit(20)
                .sort("desc", metric0);
    let group2 = cf.Attribute("sentiment_d")
                .limit(10)
                .sort("asc","sentiment_d");

    let myData = source.groupby(group1,group2)
        .metrics(rate, metric0);
    let legend = cf.Legend()
        .position("bottom")
        .width(100)
        .sort("none");
    let grid = cf.Grid()
        .top(0)
        .right(20)
        .bottom(0)
        .left(15);
    let color = cf.Color()
    color.match({
        'Positive': '#8ACE7E',
        'Neutral': '#FBDA66',
        'Negative': '#E03531',
        'Mixed': '#EE7421'
    });
    let myChart = myData.graph("Bars")
        .set("legend", legend)
        .set("grid", grid)
        .set("color", color)
        .set("orientation", "horizontal")
        .set("placement", "stacked")
        .set("dataZoom", false)
        .set('xAxis', { max: 100, min: 0 })
        .set('yAxis', {"text":"out"})
        .set("axisLabels", false);

    return myChart;
}

export const sentperairline = function () {
    let provider = cf.provider('es01');
    let source = provider.source('vc_airline_tweets');
    let metric0 = cf.Metric("count");
    let group1 = cf.Attribute("airline")
                .limit(20)
                .sort("desc", metric0);
    let group2 = cf.Attribute("sentiment_d")
                .limit(10)
                .sort("asc","sentiment_d");

    let myData = source.groupby(group1,group2)
        .metrics(metric0);
    let legend = cf.Legend()
        .position("bottom")
        .width(100)
        .sort("none");
    let grid = cf.Grid()
        .top(0)
        .right(20)
        .bottom(0)
        .left(10);
    let color = cf.Color()
    color.match({
        'Positive': '#8ACE7E',
        'Neutral': '#FBDA66',
        'Negative': '#E03531',
        'Mixed': '#EE7421'
    });
    let myChart = myData.graph("Bars")
        .set("legend", legend)
        .set("grid", grid)
        .set("color", color)
        .set("placement", "stacked")
        .set("orientation", "horizontal")
        .set("dataZoom", false)
        .set('yAxis', {"text":"out"})
        .set("axisLabels", false);

    return myChart;
}
